import React, { Fragment } from 'react'
import { Checkbox, Tabs, Radio } from 'antd'
import Restrictions from 'views/ScanSettings/NewScan/components/Restrictions'
import FullScan from 'views/ScanSettings/NewScan/components/FullScan'
import CustomScan from 'views/ScanSettings/NewScan/components/CustomScan'
import Flows from 'views/ScanSettings/NewScan/components/Flows'
import {
  SCAN_U_REMEDIATE_FIELD,
  SCAN_TYPE,
  SCAN_TYPE_FULL,
  SCAN_TYPE_CUSTOM,
  SCAN_TYPE_FLOW,
  SCAN_PREFIX
} from 'views/ScanSettings/NewScan/constants'

import { PanelsContent } from 'views/ScanSettings/NewScan/style'

const { TabPane } = Tabs

const ScanStep = ({ form, flows, restrictions, simpleMode=true, setValidationError, flowValuesForValidation }) => {
  const { getFieldDecorator, getFieldValue } = form
  const currentSelected = getFieldValue(SCAN_TYPE) || 'full'
  return (
    <Fragment>
      {getFieldDecorator(SCAN_TYPE, {
        initialValue: currentSelected
      })(
        <Radio.Group buttonStyle="solid" size="large">
          <Radio.Button value="full">FULL SCAN</Radio.Button>
          <Radio.Button value="custom">LIST</Radio.Button>
          <Radio.Button value="flow">FLOW</Radio.Button>
        </Radio.Group>
      )}
      <PanelsContent>
        {!simpleMode && currentSelected === SCAN_TYPE_FULL && (
          <Restrictions getFieldDecorator={getFieldDecorator} restrictions={restrictions} />
        )}
        <Tabs activeKey={currentSelected}>
          <TabPane tab="" key={SCAN_TYPE_FULL}>
            <FullScan getFieldDecorator={getFieldDecorator} simple={simpleMode} />
          </TabPane>
          <TabPane tab="" key={SCAN_TYPE_CUSTOM}>
            <CustomScan getFieldDecorator={getFieldDecorator} simple={simpleMode} />
          </TabPane>
          <TabPane tab="" key={SCAN_TYPE_FLOW}>
            <Flows simpleMode={simpleMode} setValidationError={setValidationError} form={form} flows={flows} prefix={SCAN_PREFIX} multiple={false} />
          </TabPane>
        </Tabs>

        <PanelsContent style={{ display: 'none' }}>
          {getFieldDecorator(SCAN_U_REMEDIATE_FIELD, {
            initialValue: false,
            valuePropName: 'checked'
          })(<Checkbox>uRemediate Inside</Checkbox>)}
        </PanelsContent>
      </PanelsContent>
    </Fragment>
  )
}

export default ScanStep
